import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';

export default function RemoveParcel(props) {
  const [show, setShow] = useState(false);
  const { parcelGroup, parcelId, updateParcels, hideTabs } = props;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const removeParcel = async () => {
    const subsToRemove = [];
    //build each unsubscribe call
    for (let i = 0; i < parcelGroup.subscriptions.length; i++) {
      const eAlertsCoreRemoveParcel = eAlertsCoreAPIEndpoint(
        ENDPOINTS.SUBSCRIPTION
      )
        .delete(parcelGroup.subscriptions[i].id)
        .catch(() => {});
      subsToRemove.push(eAlertsCoreRemoveParcel);
    }

    //execute all the calls we just built
    await Promise.all(subsToRemove)
      .catch(() => {
        const ref = '/error';
        this.props.history.push(ref);
      });

    updateParcels();
    hideTabs();
    handleClose();
  };

  return (
    <>
      <Button
        onClick={() => {
          handleShow();
        }}
        aria-label={`Remove parcel ${parcelId.replace(/-/g, " - ")}`}
        variant="link"
        size="sm"
      >
        Remove
      </Button>

      <Modal
        show={show}
        onHide={() => {
          handleClose();
        }}
      >
        <Modal.Header closeButton className="nb">
          <Modal.Title>
            <h3 className="noLine">Remove all subscriptions?</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>You will be unsubscribed from all notifications</h5>
          <br />
          <h5>for parcel #{parcelId}.</h5>
        </Modal.Body>
        <Modal.Footer className="nb">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              removeParcel();
            }}
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
